import { render, staticRenderFns } from "./SendSettings.vue?vue&type=template&id=439d6358&scoped=true"
import script from "./SendSettings.vue?vue&type=script&lang=js"
export * from "./SendSettings.vue?vue&type=script&lang=js"
import style0 from "./SendSettings.vue?vue&type=style&index=0&id=439d6358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439d6358",
  null
  
)

export default component.exports